import { StBubbleMenuPlugin } from './plugins/StBubbleMenu';

import { defineComponent, h, onBeforeUnmount, onMounted, ref, watch, nextTick } from 'vue';

export const StBubbleMenu = defineComponent({
  name: 'StBubbleMenu',

  props: {
    pluginKey: {
      type: [String, Object],
      default: 'StBubbleMenu',
    },

    editor: {
      type: Object,
      required: true,
    },

    updateDelay: {
      type: Number,
      default: undefined,
    },

    tippyOptions: {
      type: Object,
      default: () => ({}),
    },

    shouldShow: {
      type: Function,
      default: null,
    },
  },

  setup(props, { slots }) {
    const root = ref<HTMLElement | null>(null);

    onMounted(() => {
      const { updateDelay, editor, pluginKey, shouldShow, tippyOptions } = props;

      editor.registerPlugin(
        StBubbleMenuPlugin({
          updateDelay,
          editor: editor as any,
          element: root.value as HTMLElement,
          pluginKey: pluginKey as string,
          shouldShow: shouldShow as any,
          tippyOptions,
        })
      );
    });

    onBeforeUnmount(() => {
      const { pluginKey, editor } = props;

      editor.unregisterPlugin(pluginKey);
    });

    watch(
      () => props.editor,
      (editor) => {
        if (!editor) {
          return;
        }

        nextTick(() => {
          editor.registerPlugin(
            StBubbleMenuPlugin({
              updateDelay: props.updateDelay,
              editor: editor as any,
              element: root.value as HTMLElement,
              pluginKey: props.pluginKey as string,
              shouldShow: props.shouldShow as any,
              tippyOptions: props.tippyOptions,
            })
          );
        });
      },
      { immediate: true, deep: true }
    );

    return () => h('div', { ref: root }, slots.default?.());
  },
});
